// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".purchase__market{background-color:var(--yellow-color);font-family:var(--tertiary-font-family);gap:calc(var(--spacing)*.2);line-height:1;padding:.3125rem calc(var(--spacing)*.6);transition:all .3s var(--asphalte-animation-function)}.purchase__market,.purchase__market .countdown{font-size:var(--extra-small-font-size)}.purchase__market .countdown__before{padding-left:0;padding-right:calc(var(--spacing)*.4)}.reduced .purchase__market{opacity:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
